module.exports = __webpack_public_path__ + "static/media/Check.db7fe953.svg";